import { AuthService, REFRESH_OK } from "./authservice";

// Auth para instancias axios PROPIAS (gps, tickets, s3, calidad-ia). A propósito
// no usan los interceptores globales (config/session401): un 401 de esos
// microservicios no debe cerrar la sesión de Beartrack. Por eso acá, ante un
// 401, solo se intenta UNA renovación y UN reintento; el resto se propaga.

const BEARER = /^Bearer\s+/i;

/**
 * @param {import("axios").AxiosInstance} instance
 * @returns {import("axios").AxiosInstance} la misma instancia, con los interceptores puestos
 */
export function attachAuth(instance) {
  instance.interceptors.request.use(async (config) => {
    // Access vigente: si faltan <5 min o venció, renueva antes de mandar.
    const token = await AuthService.getValidAccessToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const cfg = error?.config;
      if (error?.response?.status !== 401 || !cfg || cfg.__authRetried) {
        return Promise.reject(error);
      }
      const sentToken = String(cfg.headers?.Authorization || "").replace(BEARER, "") || null;
      const renewed = await AuthService.refreshAfterUnauthorized(sentToken);
      if (renewed.status !== REFRESH_OK || !renewed.accessToken) return Promise.reject(error);
      cfg.__authRetried = true;
      cfg.headers.Authorization = `Bearer ${renewed.accessToken}`;
      return instance.request(cfg);
    }
  );

  return instance;
}
